import { Subject } from "../models/subject";

const subjectEquals = (subject1: Subject, subject2: Subject) => {
  return subject1.id === subject2.id;
};

export default subjectEquals;
